var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-with-icon"},[_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":_vm.avatarSrc,"alt":"User avatar"}})]),_c('div',{staticClass:"icon"},[_c('n-icon',_vm._b({attrs:{"name":_vm.iconName}},'n-icon',_vm.iconProps,false))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }